import React, { useRef, useState } from "react";
import styles from "./HeaderProfile.module.scss";
import { AiOutlineUser } from "react-icons/ai";
import { ProfileDropdown } from "./ProfileDropdown";
import { Overlay } from "components/Overlay";

const ProfileMenu = () => {
  const [showMenu, setShowMenu] = useState(false);
  const anchorMenu = useRef(null);

  const toggleMenu = () => setShowMenu((prev) => !prev);

  return (
    <>
      {showMenu && <Overlay hideOverlay={() => setShowMenu(false)} />}
      <div
        ref={anchorMenu}
        onClick={toggleMenu}
        className="position-relative cursor-pointer d-flex align-items-center justify-content-center"
        style={{ width: "40px", height: "40px", zIndex: 20 }}
      >
        <AiOutlineUser size={22} className={styles["profile-icon"]} />
      </div>
      <ProfileDropdown
        show={showMenu}
        anchorEl={anchorMenu.current}
        settingsEnabled={false}
        onClose={() => setShowMenu(false)}
      />
    </>
  );
};

export default ProfileMenu;
